import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import API from "../api/api";
import { toast } from "react-toastify";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (formData.newPassword !== formData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const res = await API.post("api/auth/reset-password", {
        token,
        newPassword: formData.newPassword,
      });

      toast.success(
        res.data.message || "Password reset successful. Please login."
      );
      navigate("/login");
    } catch (err) {
      console.log(err);

      toast.error(err.response?.data?.error || "Invalid or expired token.");
    }
  };

  return (
    <div
      style={{
        background: "linear-gradient(to right, #1e3c72, #2a5298)",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={5}>
            <Card
              className="shadow-lg border-0"
              style={{
                backdropFilter: "blur(10px)",
                background: "rgba(255,255,255,0.85)",
                borderRadius: "15px",
              }}
            >
              <Card.Body className="p-4">
                <h2 className="text-center mb-4 fw-bold text-primary">
                  Reset Password
                </h2>
                <Form onSubmit={handleReset}>
                  <Form.Group className="mb-3" controlId="formNewPassword">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter new password"
                      name="newPassword"
                      value={formData.newPassword}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formConfirmPassword">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Confirm new password"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 py-2 fw-semibold"
                  >
                    Reset Password
                  </Button>
                </Form>
                <div className="text-center mt-3">
                  <small className="text-muted">
                    <a href="/login">Back to Login</a>
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
